import ReportDonutChart1 from "./ReportDonutChart1.vue";

export default ReportDonutChart1;
